import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=c77178f0&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=c77178f0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77178f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c77178f0')) {
      api.createRecord('c77178f0', component.options)
    } else {
      api.reload('c77178f0', component.options)
    }
    module.hot.accept("./PageHeader.vue?vue&type=template&id=c77178f0&scoped=true", function () {
      api.rerender('c77178f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/page/PageHeader.vue"
export default component.exports